import styled from 'styled-components';

export const StyledField = styled.div`
  margin-bottom: 10px;
  input {
    margin-left: 10px;
  }
`;

export const ErrorMessage = styled.span`
  color: red;
`;
